import $ from "jquery";
import {breakpointDown} from "./Breakpoints";
import Swiper from "swiper"
import VueApp from "../app"

export default {
    mobileSelectValue: null,
    init: function () {
        this.initBreadcrumb()

        this.initFooterMobilSelectEvent()


        // Mobile Footer Select Behavior
        $(window).bind("resizeEndThrottle", () => {
            this.destroyFooterMobilSelectEvent()
            this.initFooterMobilSelectEvent()
        });

    },
    initFooterMobilSelectEvent: function () {

        if (breakpointDown("md")) {

            let $footerNav = $("#footer-nav")


            $footerNav.on("change", (item) => {
                this.handleValue(item)
            })

            /*            $footerNav.on("select", (item) => {
                            console.log(item)
                            if ($(item.currentTarget).val() !== this.mobileSelectValue){
                                this.handleValue(item)
                            }
                        })*/

        } else {
            this.destroyFooterMobilSelectEvent()
        }

    },
    handleValue(item) {
        if ($(item.currentTarget).val() === "http://null") {
            VueApp.$refs['access-prive'].handleClick()
        } else {
            window.location = $(item.currentTarget).val()
        }
    },
    destroyFooterMobilSelectEvent() {
        $("#footer-nav").off("change")
    },
    initBreadcrumb() {

        $(".swiper-container.breadcrumb").each(function (index, item) {

            let width = $(item).find("section.breadcrumb").outerWidth() + 15
            $(".swiper-container.breadcrumb .swiper-slide").width(width)


            new Swiper(item, {
                slidesPerView: "auto",
                freeMode: true,
            });
        })


    }


};